import { Fragment, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import {
  AcademicCapIcon,
  ReceiptRefundIcon,
  CashIcon,
  ClockIcon,
  BadgeCheckIcon,
  UsersIcon,
} from "@heroicons/react/solid";
import DiscordUno from "../../assets/discord1.jpeg";
import DiscordDos from "../../assets/discord2.jpeg";
import "./style.css";
import { IoChevronBackOutline } from "react-icons/io5";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Seguridad() {
  const [isOpenNft0, setIsOpenNft0] = useState(false);
  const [isOpenNft1, setIsOpenNft1] = useState(false);
  const [isOpenNft2, setIsOpenNft2] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-neutral-900">
      <div class="page-bg animation-wrapper">
        <div class="particle particle-1"></div>
      </div>
      <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
        <div className="space-y-6">
          <h1 class="text-white mt-2 block uppercase text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl">
            Mantenerse seguro
          </h1>
          <h3 class="block text-xl text-violet-600 font-semibold tracking-wide ">
            en el mundo de los NFT
          </h3>
          <a href="/learn" className="font-bold ml-2 text-left flex text-white">
            <IoChevronBackOutline className="mr-2 mt-1" /> volver 
            </a>
          
          <ul role="list" class="space-y-3 text-left">
            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft0(!isOpenNft0)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Seguridad de tu cartera
                </h2>
                <svg
                  className={`${
                    isOpenNft0
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft0}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Al comprar y vender NTFs, se recomienda tener billeteras
                      calientes y frías. Una vez que hayas comprado un NFT, se
                      recomienda transferirlo/enviarlo a tu billetera fría.
                      <strong>
                        {" "}
                        RECUERDA VERIFICAR SIEMPRE DOS VECES LA DIRECCIÓN DE LA
                        CARTERA A LA QUE ESTÁS ENVIANDO.
                      </strong>
                    </p>
                    <p>
                      Uno de los hábitos más importantes de seguridad de la
                      cartera es{" "}
                      <strong>
                        asegurarse de que desconectes tu cartera de todos los
                        sitios una vez que hayas finalizado la transacción
                        específica que te exigió conectarte
                      </strong>
                      . Esto puede ser la verificación de un NFT que posees, el
                      mintear desde un sitio web, o incluso, simplemente
                      vincularlo a Opensea. Esto garantiza que ninguna entidad
                      malintencionada pueda acceder a tu cartera desde una
                      conexión que se ha dejado activa.
                    </p>
                    <p>
                      Otra forma de seguridad de la cartera consiste en proteger
                      tanto la cartera caliente como la cartera de hardware.
                      Mantener ambos seguros es extremadamente importante, así
                      que vamos a discutir las mejores maneras de hacer
                      exactamente eso:
                    </p>
                    <ul className="list-decimal">
                      <li>
                        <strong>Seguridad de la cartera caliente:</strong>
                      </li>
                      <br />
                      <p>
                        Tu billetera MetaMask viene con una contraseña muy
                        importante y críptica - que se conoce como una{" "}
                        <strong>frase semilla</strong>. Tu frase semilla{" "}
                        <strong>
                          nunca debe ser compartida con nadie ni almacenada en
                          una plataforma digital que podría ser robada por los
                          ciberdelincuentes
                        </strong>
                        . En lugar de eso, deberías escribir tu frase semilla en
                        pedazos físicos de papel y guardarla en algún lugar
                        seguro que recordarás. Si pierdes esta frase semilla o
                        se la das a alguien, tu cartera se pierde para siempre.
                      </p>
                      <br />

                      <li>
                        <strong>
                          Cartera Hardware/Cartera fría de Seguridad:
                        </strong>
                      </li>
                      <br />
                      <p>
                        Ya sea que tengas un Ledger o un Trezor, una cartera de
                        hardware física es la mejor solución para la seguridad
                        de tus NFTs y criptografía. Tu eres la única persona que
                        gestiona los activos dentro de tu cartera fría, por lo
                        que mantenerla segura es clave.{" "}
                        <strong>
                          Coloca tu billetera en un lugar que solo tu conozcas y
                          recuerdes y fuera del alcance de cualquier niño o
                          mascota
                        </strong>
                        . Es importante tener en cuenta que solo debes comprar
                        tu cartera de hardware directamente desde el sitio web
                        de la empresa para evitar cualquier manipulación previa
                        en el dispositivo. De nuevo, si pierdes esto, pierdes el
                        contenido de tu cartera para siempre.
                      </p>
                      <br />
                    </ul>
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft1(!isOpenNft1)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Seguridad en el Discord
                </h2>
                <svg
                  className={`${
                    isOpenNft1
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft1}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      <strong>
                        Los hacks de Discord son una de las estafas más comunes
                        de NFT: La mayoría de los estafadores se acercarán a ti
                        enviando un mensaje directo fingiendo ser un miembro del
                        equipo{" "}
                      </strong>
                      . Normalmente, este es el punto de entrada de todas las
                      estafas. Los miembros del equipo del proyecto{" "}
                      <strong>NUNCA</strong> te enviarán un mensaje directo ni
                      te pedirán tu frase semilla, así que es mejor asumir que
                      todos son estafadores hasta que se demuestre lo contrario.
                      Recuerda también que debes utilizar siempre sólo fuentes
                      oficiales y leer con atención lo que estás firmando.{" "}
                      <strong>
                        Nunca mintees desde enlaces que te envíen en un mensaje
                        directo
                      </strong>
                      .
                    </p>
                    <p>
                      <strong>
                        Utiliza siempre la autenticación de dos factores de
                        seguridad para tu cuenta de Discord:
                      </strong>{" "}
                      Para aumentar la seguridad de tu cuenta, puedes{" "}
                      <strong>
                        configurar la autenticación de dos factores haciendo
                        clic en el icono del engranaje, y luego ir a "Mi
                        cuenta". Allí, verás el botón "Habilitar la
                        autenticación de dos factores"
                      </strong>
                      . Una vez que hagas clic en el botón, tendrás que
                      descargar Google Authenticator u otra aplicación de
                      autenticación en tu dispositivo móvil. Una vez hecho esto,
                      puedes vincular tu número de teléfono para que actúe como
                      método de respaldo para obtener tus códigos 2FA. Puedes
                      leer más sobre la configuración de la 2FA en detalle aquí{" "}
                      <a
                        style={{ color: "blue" }}
                        href="https://support.discord.com/hc/en-us/articles/219576828-Setting-up-Two-Factor-Authentication"
                        target="_blank"
                      >
                        https://support.discord.com/hc/en-us/articles/219576828-Setting-up-Two-Factor-Authentication
                      </a>
                    </p>
                    <p>
                      <strong>Cierra tus mensajes directos:</strong> Otra medida
                      preventiva es cerrar tus mensajes directos, lo que{" "}
                      <strong>
                        impide que alguien te envíe mensajes directos a menos
                        que lo agregues como amigo
                      </strong>
                      . En la aplicación de escritorio, haz clic en el icono del
                      engranaje situado en la esquina inferior junto a los
                      iconos del micrófono y los auriculares (desde tu móvil haz
                      clic en la foto de tu usuario).
                    </p>
                    <div className="flex-shrink-0 flex items-center">
                      <img
                        className="block h-full w-auto"
                        src={DiscordUno}
                        alt="Workflow"
                      />
                    </div>
                    <p>
                      Tras hacer clic en el icono del engranaje, ve a la sección
                      "Privacidad y seguridad". Allí encontrarás "Privacidad del
                      servidor predeterminada". Una vez desactivada, nadie podrá
                      enviarte mensajes de texto a menos que lo añadas como
                      amigo.
                    </p>
                    <div className="flex-shrink-0 flex items-center">
                      <img
                        className="block h-full w-auto"
                        src={DiscordDos}
                        alt="Workflow"
                      />
                    </div>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft2(!isOpenNft2)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Investigación de proyectos NFT
                </h2>
                <svg
                  className={`${
                    isOpenNft2
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft2}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 mt-4 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      <strong>¿Cómo sé qué es un buen proyecto de NFT?</strong>
                    </p>
                    <p>
                      Para entender lo que es un buen proyecto de NFT se
                      requiere considerar lo que se incluye en la definición de
                      "bueno". Para diferentes personas, esto puede significar
                      cosas diferentes, y lo que es bueno para uno puede no ser
                      tan atractivo para los demás.{" "}
                    </p>
                    <p>
                      En términos generales, un buen proyecto es{" "}
                      <strong>
                        aquel que tiene poder de permanencia y proporciona al
                        propietario algún beneficio a largo plazo (ya sea
                        financiero, u otro beneficio tangible)
                      </strong>{" "}
                      incluyendo arte hermoso, acceso a una comunidad, acceso a
                      otros beneficios como descuentos a eventos y mercancías,
                      acceso temprano a eventos o lanzamientos de NFTs,
                      servicios de apoyo y/o potenciales beneficios financieros.
                    </p>
                    <p>
                      Sin establecer un marco para lo que lo hace un buen
                      proyecto de NFT, las siguientes características son
                      generalmente señales de que los proyectos lleguen a ser
                      buenos o exitosos:
                    </p>
                    <p>
                      <strong>
                        <u>Equipo doxeado y experimentado:</u>
                      </strong>
                    </p>
                    <p>
                      Un equipo que ha compartido sus verdaderas identidades y
                      experiencias, a menudo (aunque no siempre), dará confianza
                      a los miembros y la comunidad del proyecto. Cuando las
                      cosas no van tan bien,{" "}
                      <strong>
                        es más difícil para un equipo doxeado alejarse
                        completamente de un proyecto comparado con uno que es
                        anónimo
                      </strong>
                      .
                    </p>
                    <p>
                      <strong>
                        <u>Arte o utilidad excepcional:</u>
                      </strong>
                    </p>
                    <p>
                      Agrupar a estos dos parece natural. Algunos proyectos
                      tienen estilos de arte espectaculares que viven como
                      marcas y que pretenden hacerlo con el tiempo, y otros
                      tienen utilidad, como el acceso a una página web o
                      herramienta online, o una comunidad que comparte alpha
                      (info) en proyectos, por ejemplo.{" "}
                      <strong>
                        Hay proyectos que tienen tanto gran arte como utilidad,
                        y estos son los que tienden a triunfar con el tiempo
                      </strong>
                      .
                    </p>
                    <p>
                      <strong>
                        <u>
                          Un proyecto que tenga una hoja de ruta y metas/valores
                          que puedas apoyar:
                        </u>
                      </strong>
                    </p>
                    <p>
                      La sensación que tienes cuando{" "}
                      <strong>apoyas una causa o un movimiento</strong> que
                      significa algo para ti no es fácil de reproducir.
                    </p>
                    <p>
                      <strong>
                        <u>Finanzas sólidas:</u>
                      </strong>
                    </p>
                    <p>
                      ¿El proyecto va a poder hacer lo que pretende? ¿Son los
                      planes demasiado ambiciosos basados en el apoyo/actividad
                      comunitaria? ¿Suman los números? Tener un proyecto que
                      tiene una{" "}
                      <strong>
                        manera de cumplir continuamente su hoja de ruta, agregar
                        elementos de la hoja de ruta, poder hacer lo que se
                        muestra en la hoja de ruta y ejecutar en alto grado
                      </strong>{" "}
                      son todos beneficios para los titulares de proyectos que
                      están bien ejecutados.
                    </p>
                    <p>
                      <strong>
                        <u>Una comunidad fuerte:</u>
                      </strong>
                    </p>
                    <p>
                      Tener una comunidad de poseedores (holders) y seguidores
                      apasionados por un proyecto{" "}
                      <strong>
                        puede llevar a una sensación de ser parte de algo
                        divertido y emocionante
                      </strong>
                      . Cuando hay demanda de quiénes están en el exterior para
                      estar en el interior, los afortunados que tienen la suerte
                      de formar parte de la base de holders de un proyecto
                      pueden cosechar la recompensa de ser conocidos por ello no
                      sólo dentro de esa comunidad, sino de otros proyectos que
                      aspiran a estar al mismo nivel.
                    </p>
                    <p>
                      <strong>
                        Otra cosa a recordar es que la "Comunidad" de holders
                        determina el punto de precio de los NFTs
                      </strong>
                      . Los proyectos harán todo el trabajo en la ejecución de
                      iniciativas de hoja de ruta, pero al final del día, el
                      precio de los NFTs en el mercado secundario son
                      determinados por los titulares.
                    </p>
                    <p>
                      Si bien los factores mencionados no son necesariamente los
                      únicos factores determinantes para los buenos proyectos de
                      NFT, los proyectos más saludables tienen la mayoría de los
                      rasgos anteriores.{" "}
                      <b>
                        Pero como de costumbre, como cualquier cosa en el mundo
                        de los NFTs, siempre es importante hacer tu propia
                        investigación (DYOR).
                      </b>
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
